import React, {ChangeEvent, useEffect, useMemo, useState} from 'react';

import {useUnit} from 'effector-react';
import debounce from 'lodash/debounce';
import {useTranslation} from 'react-i18next';

import {counterpartiesModel} from '@entities/counterparties/model';
import {Input} from '@shared/ui/Input';

import {CancelIcon} from './styled';

export const Control = () => {
    const counterparties = useUnit(counterpartiesModel);

    const {t} = useTranslation();
    const [value, setValue] = useState(counterparties.state.search);

    useEffect(() => {
        setValue(counterparties.state.search);
    }, [counterparties.state.search]);

    const debouncedSearchChanged = useMemo(
        () =>
            debounce((nextValue: string, prevValue: string) => {
                if (nextValue !== prevValue) {
                    counterparties.searchChanged(nextValue);
                }
            }, 1000),
        [],
    );

    useEffect(() => {
        debouncedSearchChanged(value, counterparties.state.search);
        return debouncedSearchChanged.cancel;
    }, [value, counterparties.state.search]);

    return (
        <div style={{minWidth: 350, maxWidth: 700}}>
            <Input
                value={value}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
                placeholder={t('page_contractor.search')}
                adornment={
                    <CancelIcon width={10} height={10} name="cross" onClick={() => setValue('')} />
                }
            />
        </div>
    );
};
